export function getObjectFromPath(path: string, baseObject: any = window): any {
    if (typeof path !== 'string' || !path) {
        // Gestion des entrées invalides
        return null;
    }
    
    let o = baseObject;
    const split = path.split('.').filter(Boolean); // Élimine les chaînes vides pour éviter les erreurs

    for (const key of split) {
        try {
            if (!(key in o)) {
                // Vérification de l'existence de la clé
                return null;
            }
            o = o[key];
        } catch (error) {
            // Gestion des erreurs d'accès
            return null;
        }
    }

    return o;
}